import React from 'react';
import PropTypes from 'prop-types';
import styles from './socOverviewMsg.module.css';

export const SocOverviewMsg = ({ content }) => {
  const {
    totals, breakdown, friendlyCancerName, exampleDrugName,
  } = content;

  const breakdownByCategories = Object
    .entries(breakdown.byCategory)
    .sort((a, b) => (b?.[1]?.count || 0) - (a?.[1]?.count || 0));

  const renderExample = (example, idx) => {
    const hasGeneric = example?.generic && example.generic !== example.name;
    return (
      <li key={idx} className={styles.listItem}>
        {example?.name}
        {hasGeneric ? (
          <em>
            {` (${example.generic})`}
          </em>
        ) : null}
      </li>
    );
  };

  const renderCategory = ([category, data]) => (
    <details key={category} className={styles.details}>
      <summary className={styles.summary}>
        {`${category} (${data.count} treatment(s))`}
      </summary>
      <div className={styles.detailsBody}>
        <ul className={styles.list}>
          {data.exampleNames.map(renderExample)}
        </ul>
      </div>
    </details>
  );

  return (
    <div className={styles.card}>
      <h4 className={styles.header}>
        {`Your Approved Treatments (${totals.treatments} Found)`}
      </h4>

      {friendlyCancerName ? (
        <p className={styles.intro}>
          {`Here is a breakdown of the types of approved treatments matched for your ${friendlyCancerName}:`}
        </p>
      ) : null}

      {breakdownByCategories.map(renderCategory)}

      <p className={styles.footerText}>
        You can ask for more details about any treatment, for example,
        {' '}
        {`"Tell me more about ${exampleDrugName || 'a specific treatment'}".`}
      </p>
    </div>
  );
};

SocOverviewMsg.propTypes = {
  content: PropTypes.shape({
    totals: PropTypes.shape({
      treatments: PropTypes.number.isRequired,
    }).isRequired,
    breakdown: PropTypes.shape({
      byCategory: PropTypes.objectOf(PropTypes.shape({
        count: PropTypes.number.isRequired,
        exampleNames: PropTypes.arrayOf(PropTypes.shape({
          name: PropTypes.string.isRequired,
          generic: PropTypes.string,
        })).isRequired,
      })).isRequired,
    }).isRequired,
    friendlyCancerName: PropTypes.string,
    exampleDrugName: PropTypes.string,
  }).isRequired,
};
